import { ContentWrapper, NoRecord, Textbox } from 'components/generic';
import { useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { CKEditor } from 'ckeditor4-react';
import { colors } from 'config';
import { textFormatter } from 'utils';
import classNames from 'classnames';
import { cloneDeep } from 'lodash';
import Images from 'assets/Images';
import { TemplateContext } from 'providers/template-provider';
import './style.scss';

const TemplateConfig = () => {
	const factList = useSelector(state => state?.factList)?.data;
	const context = useContext(TemplateContext);
	const { setCreateObj, createObj } = context;
	const [editor, setEditor] = useState();
	const [displayFacts, setDisplayFacts] = useState([]);

	useEffect(() => factList && setDisplayFacts(factList), [factList]);

	const handleSearch = e => {
		const list = cloneDeep(factList);
		setDisplayFacts(list?.filter(el => el?.fa_name?.toLowerCase()?.includes(e?.toLowerCase())));
	};

	const handleSelectFact = el => {
		if (editor) {
			editor.insertText(`[${el?.fa_key}]`);
		}
	};

	const dataHandler = (e, key) => {
		setCreateObj(prevState => ({ ...prevState, [key]: e }));
	};

	return (
		<>
			<ContentWrapper shadow>
				<div className='templateConfig space-between'>
					<ul className='scroll-bar templateConfig__facts destination__list'>
						<h4>Select dynamic fields</h4>
						<div className='destination__search'>
							<div className='destination__search--img'>
								<img src={Images?.search} alt='search' />
							</div>
							<input placeholder='Search' onChange={e => handleSearch(e?.target?.value)} />
						</div>
						{displayFacts?.map((el, i) => (
							<li key={el?.fa_name}>
								<span style={{ backgroundColor: colors[i % colors.length] }}>{el?.fa_name?.substring(0, 2) || el?.key?.substring(0, 2)}</span> {textFormatter(el?.fa_name || el?.value)}
								<div className='destination__add'>
									<img src={Images?.addOperator} alt='add' onClick={() => handleSelectFact(el)} />
								</div>
							</li>
						))}
						{!displayFacts?.length && <NoRecord height='200px' imageHeight='150px' imageWidth='150px' header='No facts found' />}
					</ul>

					<div className={classNames({ templateConfig__editor: true })}>
						{createObj?.templateType === 'email' && <Textbox label='Template Subject' mandatory placeholder='Eg: Payment Remainder' value={createObj?.templateSubject} onChange={e => dataHandler(e?.target?.value, 'templateSubject')} />}
						<CKEditor
							initData={createObj?.templateContent || ''}
							config={{ allowedContent: true, height: 200, uiColor: '#EFF1F5' }}
							onInstanceReady={event => setEditor(event?.editor)}
							onChange={event => dataHandler(event?.editor?.getData(), 'templateContent')}
						/>
					</div>
				</div>
			</ContentWrapper>
		</>
	);
};

export default TemplateConfig;
